import type { SharedTab } from '@/domain/SharedTab.ts';
import type { AppState } from '@/store/store.ts';
import { selectFullTab } from '@/store/workspace/selector.ts';

export function selectSharedTabToSave(state: AppState): SharedTab | undefined {
  const tab = selectFullTab(state);

  if (!tab?.isShared) {
    return;
  }

  return {
    clientId: tab.clientId,
    ownerEmail: tab.ownerEmail,
    products: tab.products,
    tiles: tab.tiles,
    tabName: tab.tabName,
    tabType: tab.tabType,
    sharedWithEmails: tab.sharedWithUsers,
    tabId: tab?.id,
    version: 'forex' as const,
  };
}
